module.exports = __webpack_public_path__ + "static/media/master_im_head.2f2d4b0a.jpg";